import { AfterViewInit, Component, ElementRef, Input, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-bidder-user-terms',
  templateUrl: './bidder-user-terms.component.html',
  styleUrls: ['./bidder-user-terms.component.sass'],
  encapsulation: ViewEncapsulation.Emulated
})
export class BidderUserTermsComponent implements AfterViewInit {
  @Input() isTermsPage: boolean = false;
  @Input() content?: string;

  @ViewChild('viewContent') viewContent?: ElementRef
  constructor(
    public modalService: NgbModal,
  ) { }

  ngAfterViewInit(): void {
    if (this.content) {
      this.viewContent!.nativeElement.innerHTML = this.content!;
    }
  }
  modalClose(){
    this.modalService.dismissAll()
   }

}
